import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Checkbox,
  Autocomplete,
  IconButton,
  CircularProgress,
  Card,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getFormInstanceByid,
  updateFormInstance,
} from "../../../redux/slices/forms.slice";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  setHeaderTitle,
  setSnackbar,
} from "../../../redux/slices/common.slice";
import {
  getAllProject,
  ProjectLocationAutoCompleteSuggesstionThunk,
} from "../../../redux/slices/tenant.slice";

import Loader from "../Loader";
import Select from "react-select";

import { getAllServiceUnit } from "../../../redux/slices/serviceUnit.slice";

import { AddCircleOutline, PhotoCamera } from "@mui/icons-material";
import { useSelector } from "react-redux";
import logAnalyticsEvent from "../../../firebase/analyticsLogger";
import ReactQuill from "react-quill";
import { modules } from "../../../utils/icon/CommonFunctions";

const customStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #ced4da",
    borderRadius: "4px",

    minHeight: "40px", // Mimicking MUI's small size
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "rgba(25, 118, 210, 0.08)" // Highlight selected item with color
      : state.isFocused
      ? "#fafafa" // Hover effect
      : "white",
    color: "black",
    "&:active": {
      backgroundColor: "rgba(25, 118, 210, 0.08)",
    },
  }),
};
const EditForm = ({ mode, form_id = null, height = "calc(100vh - 180px)" }) => {
  const [formData, setFormData] = useState([]);
  const formRef = useRef(null);
  const { formId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [token, setToken] = useState();
  const navigate = useNavigate();

  const [parentFormId, setParentFormId] = useState(null);
  const [errors, setErrors] = useState({});
  const [locationOption, setLocationOption] = useState([]);
  const [serviceUnitOptions, setServiceUnitOptions] = useState();
  const [serviceUnit, setServiceUnit] = useState();
  const [projectOptions, setProjectOptions] = useState();
  const [project, setProject] = useState();
  const location = useLocation(); // Access the current location (URL)
  const [formType, setFormType] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [selectedUsers, setSelectedUsers] = useState();
  const [owners, setOwners] = useState([]);
  const [site, setSite] = useState();
  const [signature, setSignature] = useState("");
  const users = useSelector((state) => state.common.users);
  const user = useSelector((state) => state.user);

  const [notes, setNotes] = useState({});
  const state = location.state;

  useEffect(() => {
    if (state && !form_id) {
      if (state?.displayName) dispatch(setHeaderTitle(state?.displayName));
      else {
        dispatch(setHeaderTitle(""));
      }
    }
  }, [state, form_id]);

  const fetchAllserviceUnit = async () => {
    setLoading(true);

    try {
      let response = await dispatch(
        getAllServiceUnit({
          page_number: 1,
        })
      );

      const { payload } = response;
      if (payload?.status) {
        setServiceUnitOptions(
          payload?.data?.map((item, idx) => ({
            label: item.name,
            value: item.id,
          }))
        );
        if (state?.serviceUnitId) {
          const temp = payload?.data?.find(
            (item, idx) => item.id === +state?.serviceUnitId
          );
          if (temp) {
            setServiceUnit({
              label: temp.name,
              value: temp.id,
            });
            setOwners(temp?.owners);
            setSite(temp?.project);
          }
        }
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: "Internal server error",
        })
      );
    }

    setLoading(false);
  };
  useEffect(() => {
    if (formType === "inspection") fetchAllserviceUnit();
  }, [formType]);

  const fetchAllProject = async () => {
    setLoading(true);
    // const networkTrace = trace(performance, "load_projects");
    // networkTrace.start(); // Start the trace
    try {
      let response = await dispatch(
        getAllProject({
          page_number: 1,
          page_size: 100000,
        })
      );
      const { payload } = response;
      if (payload?.status) {
        setProjectOptions(
          payload?.data?.map((item, idx) => ({
            label: item.name,
            value: item.id,
          }))
        );
      } else
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllProject();
  }, []);
  const handleInputChange = (
    value,
    questionId,
    sectionIndex,
    questionIndex
  ) => {
    const updatedFormData = [...formData];

    updatedFormData[sectionIndex].questions[questionIndex].answer = value;

    setFormData(updatedFormData);
  };
  const handleMediaChange = (
    newImages,
    questionId,
    sectionIndex,
    questionIndex
  ) => {
    const updatedFormData = [...formData];

    // Get the existing images, or initialize as an empty array if undefined
    const existingImages =
      updatedFormData[sectionIndex].questions[questionIndex].images || [];

    // Append the new images to the existing ones
    updatedFormData[sectionIndex].questions[questionIndex].images = [
      ...existingImages,
      ...newImages,
    ];

    setFormData(updatedFormData);
  };
  const handleVideoChange = (
    newVideos,
    questionId,
    sectionIndex,
    questionIndex
  ) => {
    const updatedFormData = [...formData];

    // Get the existing images, or initialize as an empty array if undefined
    const existingVideos =
      updatedFormData[sectionIndex].questions[questionIndex].videos || [];

    // Append the new images to the existing ones
    updatedFormData[sectionIndex].questions[questionIndex].videos = [
      ...existingVideos,
      ...newVideos,
    ];

    setFormData(updatedFormData);
  };

  const handleDeleteImage = (
    indexToDelete,
    questionId,
    sectionIndex,
    questionIndex
  ) => {
    const updatedFormData = [...formData];

    // Get the current list of images
    const currentImages =
      updatedFormData[sectionIndex].questions[questionIndex].images || [];

    // Filter out the image that needs to be deleted based on index
    const updatedImages = currentImages.filter((_, i) => i !== indexToDelete);

    // Update the question's images
    updatedFormData[sectionIndex].questions[questionIndex].images =
      updatedImages;

    setFormData(updatedFormData);
  };
  const handleDeleteVideo = (
    indexToDelete,
    questionId,
    sectionIndex,
    questionIndex
  ) => {
    const updatedFormData = [...formData];

    // Get the current list of images
    const currentVideos =
      updatedFormData[sectionIndex].questions[questionIndex].videos || [];

    // Filter out the image that needs to be deleted based on index
    const updatedVideos = currentVideos.filter((_, i) => i !== indexToDelete);

    // Update the question's images
    updatedFormData[sectionIndex].questions[questionIndex].videos =
      updatedVideos;

    setFormData(updatedFormData);
  };

  const handleRadioChange = (e, questionId, sectionIndex, questionIndex) => {
    const { value } = e.target;

    const updatedFormData = [...formData];

    updatedFormData[sectionIndex].questions[questionIndex].group_value = value;

    setFormData(updatedFormData);
  };

  const handleCheckboxChange = (e, sectionIndex, questionIndex) => {
    const { checked } = e.target;

    // Create a deep copy of the form data to avoid directly mutating the state.
    const updatedFormData = [...formData];

    // Update the is_selected field for the checkbox question.
    updatedFormData[sectionIndex].questions[questionIndex].is_selected =
      checked;

    // Update the state.
    setFormData(updatedFormData);
  };
  const handleUsersChange = (
    value,
    questionId,
    sectionIndex,
    questionIndex
  ) => {
    const updatedFormData = [...formData];

    updatedFormData[sectionIndex].questions[questionIndex].users = value?.map(
      (item) => item.value
    );

    setFormData(updatedFormData);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!selectedUser && formType === "work_permit")
      newErrors["user"] = "Required";

    formData.forEach((section) => {
      section.questions.forEach((question) => {
        if (question.label === "Email") {
          // Check here for email validation
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Simple email regex
          if (!emailRegex.test(question.answer)) {
            newErrors[question.question_id] = `Invalid Email Format`;
          }
        }
        if (question.required) {
          if (question.answer_type === "CheckBox") {
            // Checkbox can be unchecked, handle accor dingly
            if (!question.is_selected) {
              newErrors[question.question_id] = `Required`;
            }
          } else if (question.answer_type === "Media") {
            if (question?.images.length === 0) {
              newErrors[question.question_id] = `Required`;
            }
          } else if (question.answer_type === "Video") {
            if (question?.videos.length === 0) {
              newErrors[question.question_id] = `Required`;
            }
          } else if (question.answer_type === "Users") {
            if (question?.users.length === 0) {
              newErrors[question.question_id] = `Required`;
            }
          } else if (!question.answer || question.answer === "<p><br></p>") {
            newErrors[question.question_id] = `Required`;
          }
        }
      });
    });
    setErrors(newErrors);
    scrollToError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const scrollToError = (errors) => {
    const errorField = Object.keys(errors)[0]; // Get the first error field

    const errorElement = document.getElementById(errorField); // Find the DOM element of that field

    if (errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "center" }); // Scroll to the error field
    }
  };

  function removeUntilFirstComma(str) {
    const commaIndex = str.indexOf(",");
    if (commaIndex !== -1) {
      return str.substring(commaIndex + 1); // +1 to skip the comma itself
    }
    return str; // return original string if no comma is found
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setSubmitLoading(true);
    // Create a deep copy of formData to avoid direct mutation
    const updatedJson = formData?.map((section, sectionIndex) => {
      return {
        ...section,
        questions: section.questions.map((question, questionIndex) => {
          if (question.answer_type === "Media") {
            return {
              ...question,
              images:
                question.images?.map((img) => {
                  if (img.base) {
                    return {
                      ...img,
                      base: removeUntilFirstComma(img.base),
                    };
                  }
                  return img; // Return unchanged image if no base is present
                }) || [],
              others: notes[question.question_id] || null,
            };
          } else if (question.answer_type === "Video") {
            return {
              ...question,
              videos:
                question.videos?.map((img) => {
                  if (img.base) {
                    return {
                      ...img,
                      base: removeUntilFirstComma(img.base),
                    };
                  }
                  return img; // Return unchanged image if no base is present
                }) || [],
              others: notes[question.question_id] || null,
            };
          }
          console.log(notes[question.question_id]);
          return { ...question, others: notes[question.question_id] || null }; // Return unchanged question if answer_type is not "Media"
        }),
      };
    });

    try {
      let response = await dispatch(
        updateFormInstance({
          formData: {
            form: parentFormId,
            submission_json: updatedJson,
            service_unit: serviceUnit?.value,
            user: selectedUser ? selectedUser?.value : undefined,
          },
          formId: form_id ? form_id : formId,
        })
      );
      const { payload } = response;
      if (payload && payload.status) {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "success",
            message: "Data updated Succesfully.",
          })
        );
        logAnalyticsEvent("update_form_submission", {
          user_id: user?.data?.user?.id,
        });
        navigate(-1);
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload.message || "Internal server error",
          })
        );
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: error || "Internal server error",
        })
      );
    }
    setSubmitLoading(false);
  };

  const fetchFormInstanceByid = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getFormInstanceByid({ formId: form_id ? form_id : formId })
      );
      const { payload } = response;
      if (payload?.status) {
        setFormData(payload?.data?.submission_json);

        setToken(payload?.token);
        setParentFormId(payload?.data?.form);
        setFormType(payload?.data?.form_type);

        //for notes

        payload?.data?.submission_json?.map((section, i) =>
          section.questions.map((question, j) => {
            console.log(question.others);
            if (question.others) {
              setNotes((prev) => ({
                ...prev,
                [question.question_id]: question.others,
              }));
            }
          })
        );

        if (payload?.data?.form_type === "work_permit")
          setSelectedUser({
            label: `${payload?.data?.user?.first_name} ${payload?.data?.user?.last_name}`,
            value: payload?.data?.user?.id,
          });

        if (
          payload?.data?.form_type === "inspection" ||
          payload?.data?.form_type === "audit"
        ) {
          if (payload?.data?.auditor)
            setSelectedUser({
              label: `${payload?.data?.auditor?.first_name} ${payload?.data?.auditor?.last_name}`,
              value: payload?.data?.auditor?.id,
            });
          if (payload?.data?.auditor_sign)
            setSignature(
              `${payload?.data?.auditor_sign?.img_url}?${payload?.token}`
            );
        }
      }
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => {
    fetchFormInstanceByid();
  }, []);

  let timeOut = null;
  const handleAutocompleteChange = (event, values) => {
    if (values !== "") {
      if (timeOut) clearTimeout(timeOut);

      timeOut = setTimeout(async () => {
        try {
          const response = await ProjectLocationAutoCompleteSuggesstionThunk({
            location: values,
          });
          const suggestionList = response.data; // Adjust this based on the structure of your response
          let temp = [];
          suggestionList?.predictions?.map((element) => {
            temp.push({
              label: element?.description,
              value: element?.place_id,
            });
          });
          setLocationOption(temp);
        } catch (error) {}
      }, 500);
    }
  };
  console.log(notes);
  return (
    <>
      {submitLoading && <Loader />}
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={12}>
          <Box className="box-container" sx={{ height: height }}>
            {loading ? (
              <Box sx={{ height: "100%" }} className="center">
                <CircularProgress />
              </Box>
            ) : (
              <>
                {" "}
                {formType === "work_permit" && (
                  <>
                    <Typography variant="body1" component="label">
                      Select User
                      <span style={{ color: "red" }}> *</span>
                    </Typography>
                    <Select
                      options={users}
                      value={selectedUser}
                      onChange={(e) => {
                        setSelectedUser(e);
                        setErrors((prevErrors) => {
                          const newErrors = { ...prevErrors };
                          delete newErrors["user"];
                          return newErrors;
                        });
                      }}
                      menuPortalTarget={document.body}
                      styles={customStyles}
                      placeholder="Select Users"
                    />
                    {errors["user"] && (
                      <div className="form-error-message">{errors["user"]}</div>
                    )}
                    <br />
                  </>
                )}
                {formType === "inspection" && (
                  <Card
                    sx={{
                      padding: "16px",
                      marginBottom: "16px !important",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "16px !important",
                            fontWeight: 500,
                          }}
                        >
                          <b> Equipment:</b> {serviceUnit?.label || "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "16px !important",
                            fontWeight: 500,
                          }}
                        >
                          <b> Site:</b> {site?.name || "-"}
                        </Typography>
                      </Grid>

                      {/* Owners Information */}
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                          }}
                        >
                          Owners:
                        </Typography>
                        <Grid container>
                          {owners?.length > 0 ? (
                            owners.map((item, index) => (
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  key={index}
                                  variant="body2"
                                  sx={{
                                    fontSize: "15px !important",
                                    lineHeight: "1.6",
                                    marginBottom: "8px",
                                    color: "#333",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#036185",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Name:{" "}
                                  </span>
                                  {item?.first_name + " " + item?.last_name}
                                  <br />
                                  <span
                                    style={{
                                      color: "#036185",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Email:{" "}
                                  </span>
                                  {item?.email}
                                </Typography>
                              </Grid>
                            ))
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "15px !important",
                                fontStyle: "italic",
                                color: "#666",
                              }}
                            >
                              -
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                )}
                <form ref={formRef}>
                  {formData &&
                    formData.map((section, sectionIndex) => (
                      <Accordion key={section.section} defaultExpanded={true}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon className="expand-icon" />
                          }
                          className="accordion-summary-background accordion-summary-root"
                        >
                          <Typography className="accordion-summary-typography">
                            {section.section_name}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          className={
                            mode === "view"
                              ? "form-disabled accordion-details"
                              : "accordion-details"
                          }
                        >
                          <Grid container spacing={3}>
                            {section.questions.map(
                              (question, questionIndex) => (
                                <Grid
                                  item
                                  lg={question.width || 6}
                                  xs={12}
                                  key={question.question_id}
                                >
                                  <Typography
                                    variant="label"
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "14px !important",
                                    }}
                                  >
                                    {question.label}
                                    {question.required && (
                                      <span style={{ color: "red" }}> *</span>
                                    )}
                                  </Typography>

                                  {question.answer_type === "Text Field" && (
                                    <>
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Your answer here"
                                        required={question.required}
                                        name={question.question_id}
                                        id={question.question_id}
                                        size="small"
                                        value={question.answer || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e.target.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                            delete newErrors[
                                              question.question_id
                                            ]; // Remove the error for the specific question using its name
                                            return newErrors; // Return the updated errors object
                                          });
                                        }}
                                        error={!!errors[question.question_id]} // Shows error if validation fails
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Rich_TextBox" && (
                                    <>
                                      <Box className={"rich-editor"}>
                                        <ReactQuill
                                          theme="snow"
                                          value={question.answer || ""}
                                          modules={modules}
                                          required={question.required}
                                          name={question.question_id}
                                          id={question.question_id}
                                          onChange={(values) => {
                                            handleInputChange(
                                              values,
                                              question.question_id,
                                              sectionIndex,
                                              questionIndex
                                            );
                                            setErrors((prevErrors) => {
                                              const newErrors = {
                                                ...prevErrors,
                                              }; // Create a copy of the previous errors state
                                              delete newErrors[
                                                question.question_id
                                              ]; // Remove the error for the specific question using its name
                                              return newErrors; // Return the updated errors object
                                            });
                                          }}
                                          error={!!errors[question.question_id]}
                                        />
                                      </Box>
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Date" && (
                                    <>
                                      <TextField
                                        type="date"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        required={question.required}
                                        name={question.question_id}
                                        id={question.question_id}
                                        value={question.answer || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e.target.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                            delete newErrors[
                                              question.question_id
                                            ]; // Remove the error for the specific question using its name
                                            return newErrors; // Return the updated errors object
                                          });
                                        }}
                                        error={!!errors[question.question_id]}
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {question.answer_type === "Number" && (
                                    <>
                                      <TextField
                                        type="number"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        required={question.required}
                                        name={question.question_id}
                                        id={question.question_id}
                                        value={question.answer || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e.target.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                            delete newErrors[
                                              question.question_id
                                            ]; // Remove the error for the specific question using its name
                                            return newErrors; // Return the updated errors object
                                          });
                                        }}
                                        error={!!errors[question.question_id]}
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {question.answer_type === "Time" && (
                                    <>
                                      <TextField
                                        type="time"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        required={question.required}
                                        name={question.question_id}
                                        id={question.question_id}
                                        value={question.answer || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e.target.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                            delete newErrors[
                                              question.question_id
                                            ]; // Remove the error for the specific question using its name
                                            return newErrors; // Return the updated errors object
                                          });
                                        }}
                                        error={!!errors[question.question_id]}
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {question.answer_type === "Date & Time" && (
                                    <>
                                      <TextField
                                        type="datetime-local"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        required={question.required}
                                        name={question.question_id}
                                        id={question.question_id}
                                        value={question.answer || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e.target.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                            delete newErrors[
                                              question.question_id
                                            ]; // Remove the error for the specific question using its name
                                            return newErrors; // Return the updated errors object
                                          });
                                        }}
                                        error={!!errors[question.question_id]}
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Location" && (
                                    <>
                                      <Autocomplete
                                        className="project-location-autocomplete"
                                        freeSolo
                                        size="small"
                                        value={question.answer}
                                        onInputChange={(event, values) => {
                                          handleAutocompleteChange(
                                            event,
                                            values
                                          );
                                        }}
                                        onChange={(e, valuee) => {
                                          handleInputChange(
                                            valuee.label,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                            delete newErrors[
                                              question.question_id
                                            ]; // Remove the error for the specific question using its name
                                            return newErrors; // Return the updated errors object
                                          });
                                        }}
                                        error={!!errors[question.question_id]}
                                        options={locationOption}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label=""
                                            fullWidth
                                            variant="outlined"
                                            // required={question.required}
                                            name={question.question_id}
                                            id={question.question_id}
                                            // value={question.answer || ""}
                                            placeholder="Please, Enter location"
                                          />
                                        )}
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Radio Buttons" && (
                                    <FormControl
                                      component="fieldset"
                                      fullWidth
                                      required
                                    >
                                      <RadioGroup
                                        name={`${question.question_id}`}
                                        id={question.question_id}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                        value={question.group_value || ""}
                                        onChange={(e) =>
                                          handleRadioChange(
                                            e,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          )
                                        }
                                      >
                                        {question.options?.map(
                                          (option, index) => (
                                            <FormControlLabel
                                              key={index}
                                              value={option}
                                              control={<Radio />}
                                              label={option}
                                            />
                                          )
                                        )}
                                      </RadioGroup>
                                    </FormControl>
                                  )}

                                  {question.answer_type === "Media" && (
                                    <>
                                      {question.images &&
                                        question.images.length > 0 && (
                                          <Box sx={{ mt: 2 }}>
                                            {/* Display all images in a single grid */}
                                            <Grid container spacing={2}>
                                              {question.images.map(
                                                (image, index) => (
                                                  <Grid item xs={2} key={index}>
                                                    {image.img_url ? (
                                                      <Box
                                                        sx={{
                                                          position: "relative",
                                                          borderRadius: "8px",
                                                          overflow: "hidden",
                                                        }}

                                                        // target="_blank"
                                                      >
                                                        {/* Display the image, whether it is img_url or base64 */}
                                                        <Link
                                                          to={`${image.img_url}?${token}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <img
                                                            src={`${image.img_url}?${token}`}
                                                            alt={`something went wrong`}
                                                            style={{
                                                              width: "100%", // Set the desired width
                                                              height: "100%", // Adjust as necessary
                                                              objectFit:
                                                                "cover",
                                                              borderRadius:
                                                                "8px",
                                                            }}
                                                          />
                                                        </Link>

                                                        {/* Delete Icon */}
                                                        <IconButton
                                                          size="small"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            handleDeleteImage(
                                                              index,
                                                              question.question_id,
                                                              sectionIndex,
                                                              questionIndex
                                                            );
                                                          }}
                                                          sx={{
                                                            position:
                                                              "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor:
                                                              "rgba(0, 0, 0, 0.5)",
                                                            color: "white",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "rgba(0, 0, 0, 0.8)",
                                                            },
                                                          }}
                                                        >
                                                          <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                      </Box>
                                                    ) : (
                                                      <Box
                                                        sx={{
                                                          position: "relative",
                                                          borderRadius: "8px",
                                                          overflow: "hidden",
                                                        }}

                                                        // target="_blank"
                                                      >
                                                        {/* Display the image, whether it is img_url or base64 */}
                                                        <img
                                                          src={image.base}
                                                          alt={`something went wrong`}
                                                          style={{
                                                            width: "100%", // Set the desired width
                                                            height: "100%", // Adjust as necessary
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                          }}
                                                        />

                                                        {/* Delete Icon */}
                                                        <IconButton
                                                          size="small"
                                                          onClick={() =>
                                                            handleDeleteImage(
                                                              index,
                                                              question.question_id,
                                                              sectionIndex,
                                                              questionIndex
                                                            )
                                                          }
                                                          sx={{
                                                            position:
                                                              "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor:
                                                              "rgba(0, 0, 0, 0.5)",
                                                            color: "white",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "rgba(0, 0, 0, 0.8)",
                                                            },
                                                          }}
                                                        >
                                                          <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                      </Box>
                                                    )}
                                                  </Grid>
                                                )
                                              )}
                                            </Grid>
                                          </Box>
                                        )}
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<PhotoCamera />}
                                        sx={{
                                          mt: 1,

                                          color: "#036185",
                                          width: "100% ",
                                        }}
                                      >
                                        Upload Images
                                        <input
                                          type="file"
                                          accept="image/*"
                                          hidden
                                          name={question.question_id}
                                          id={question.question_id}
                                          multiple // Allow multiple files
                                          onChange={(e) => {
                                            const files = e.target.files;
                                            setErrors((prevErrors) => {
                                              const newErrors = {
                                                ...prevErrors,
                                              }; // Create a copy of the previous errors state
                                              delete newErrors[
                                                question.question_id
                                              ]; // Remove the error for the specific question using its name
                                              return newErrors; // Return the updated errors object
                                            });
                                            const imageList = Array.from(
                                              files
                                            ).map((file) => {
                                              const reader = new FileReader();
                                              return new Promise((resolve) => {
                                                reader.onloadend = () => {
                                                  resolve({
                                                    base: reader.result,
                                                    extension:
                                                      file.type.split("/")[1], // Get the file extension
                                                    img_url: null,
                                                  });
                                                };
                                                reader.readAsDataURL(file);
                                              });
                                            });

                                            Promise.all(imageList).then(
                                              (images) => {
                                                handleMediaChange(
                                                  images,
                                                  question.question_id,
                                                  sectionIndex,
                                                  questionIndex
                                                );
                                              }
                                            );
                                          }}
                                        />
                                      </Button>

                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Video" && (
                                    <>
                                      {question.videos &&
                                        question.videos.length > 0 && (
                                          <Box sx={{ mt: 2 }}>
                                            {/* Display all videos in a single grid */}
                                            <Grid container spacing={2}>
                                              {question.videos.map(
                                                (video, index) => (
                                                  <Grid item xs={2} key={index}>
                                                    {video.video_url ? (
                                                      <Box
                                                        sx={{
                                                          position: "relative",
                                                          borderRadius: "8px",
                                                          overflow: "hidden",
                                                        }}
                                                      >
                                                        {/* Display the video if the URL exists */}
                                                        <Link
                                                          to={`${video.video_url}?${token}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <video
                                                            src={`${video.video_url}?${token}`}
                                                            alt="video preview"
                                                            controls
                                                            style={{
                                                              width: "100%", // Set the desired width
                                                              height: "100%", // Adjust as necessary
                                                              objectFit:
                                                                "cover",
                                                              borderRadius:
                                                                "8px",
                                                            }}
                                                          />
                                                        </Link>

                                                        {/* Delete Icon */}
                                                        <IconButton
                                                          size="small"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            handleDeleteVideo(
                                                              index,
                                                              question.question_id,
                                                              sectionIndex,
                                                              questionIndex,
                                                              "video" // Pass media type for deleting videos
                                                            );
                                                          }}
                                                          sx={{
                                                            position:
                                                              "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor:
                                                              "rgba(0, 0, 0, 0.5)",
                                                            color: "white",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "rgba(0, 0, 0, 0.8)",
                                                            },
                                                          }}
                                                        >
                                                          <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                      </Box>
                                                    ) : (
                                                      <Box
                                                        sx={{
                                                          position: "relative",
                                                          borderRadius: "8px",
                                                          overflow: "hidden",
                                                        }}
                                                      >
                                                        {/* Display the video preview from base64 if URL doesn't exist */}
                                                        <video
                                                          src={video.base}
                                                          alt="video preview"
                                                          controls
                                                          style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                          }}
                                                        />

                                                        {/* Delete Icon */}
                                                        <IconButton
                                                          size="small"
                                                          onClick={() =>
                                                            handleDeleteVideo(
                                                              index,
                                                              question.question_id,
                                                              sectionIndex,
                                                              questionIndex
                                                            )
                                                          }
                                                          sx={{
                                                            position:
                                                              "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor:
                                                              "rgba(0, 0, 0, 0.5)",
                                                            color: "white",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "rgba(0, 0, 0, 0.8)",
                                                            },
                                                          }}
                                                        >
                                                          <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                      </Box>
                                                    )}
                                                  </Grid>
                                                )
                                              )}
                                            </Grid>
                                          </Box>
                                        )}

                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<PhotoCamera />}
                                        sx={{
                                          mt: 1,

                                          color: "#036185",
                                          width: "100%",
                                        }}
                                      >
                                        Upload Videos (max. 20MB)
                                        <input
                                          type="file"
                                          accept="video/*"
                                          hidden
                                          name={question.question_id}
                                          id={question.question_id}
                                          multiple
                                          onChange={(e) => {
                                            const files = e.target.files;
                                            const MAX_SIZE_MB = 20;
                                            const MAX_SIZE_BYTES =
                                              MAX_SIZE_MB * 1024 * 1024;

                                            // Filter files by size
                                            const validFiles = Array.from(
                                              files
                                            ).filter(
                                              (file) =>
                                                file.size <= MAX_SIZE_BYTES
                                            );
                                            const invalidFiles = Array.from(
                                              files
                                            ).filter(
                                              (file) =>
                                                file.size > MAX_SIZE_BYTES
                                            );

                                            // Handle errors for invalid files
                                            if (invalidFiles.length > 0) {
                                              setErrors((prevErrors) => ({
                                                ...prevErrors,
                                                [question.question_id]: `Some Videos are too large. Maximum size allowed is ${MAX_SIZE_MB}MB.`,
                                              }));
                                            } else {
                                              setErrors((prevErrors) => {
                                                const newErrors = {
                                                  ...prevErrors,
                                                };
                                                delete newErrors[
                                                  question.question_id
                                                ];
                                                return newErrors;
                                              });
                                            }

                                            // Process valid files
                                            const videoList = validFiles.map(
                                              (file) => {
                                                const reader = new FileReader();
                                                return new Promise(
                                                  (resolve) => {
                                                    reader.onloadend = () => {
                                                      resolve({
                                                        base: reader.result, // Read as base64
                                                        extension:
                                                          file.type.split(
                                                            "/"
                                                          )[1], // Get file extension
                                                        video_url: null, // URL is not available until the file is uploaded
                                                      });
                                                    };
                                                    reader.readAsDataURL(file); // Read file as base64
                                                  }
                                                );
                                              }
                                            );

                                            Promise.all(videoList).then(
                                              (videos) => {
                                                handleVideoChange(
                                                  videos,
                                                  question.question_id,
                                                  sectionIndex,
                                                  questionIndex
                                                );
                                              }
                                            );
                                          }}
                                        />
                                      </Button>

                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "CheckBox" && (
                                    <>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              question.is_selected || false
                                            }
                                            id={question.question_id}
                                            sx={{ marginLeft: "10px" }}
                                            onChange={(e) => {
                                              handleCheckboxChange(
                                                e,
                                                sectionIndex,
                                                questionIndex
                                              );
                                              setErrors((prevErrors) => {
                                                const newErrors = {
                                                  ...prevErrors,
                                                }; // Create a copy of the previous errors state
                                                delete newErrors[
                                                  question.question_id
                                                ]; // Remove the error for the specific question using its name
                                                return newErrors; // Return the updated errors object
                                              });
                                            }}
                                          />
                                        }
                                      />
                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Service Unit" && (
                                    <>
                                      <Select
                                        options={serviceUnitOptions}
                                        value={
                                          serviceUnit || // Use state value if available
                                          serviceUnitOptions?.find(
                                            (item) =>
                                              item.value === +question?.answer
                                          ) ||
                                          null // Fallback when data loads
                                        }
                                        menuPortalTarget={document.body}
                                        onChange={(e) => {
                                          setServiceUnit(e); // Update state with selected value
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors };
                                            delete newErrors[
                                              `${question.question_id}`
                                            ];
                                            return newErrors;
                                          });
                                          handleInputChange(
                                            e.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                        }}
                                        name={`${question.question_id}`}
                                        id={question.question_id}
                                        styles={customStyles}
                                        placeholder="Select Type"
                                      />

                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Project" && (
                                    <>
                                      <Select
                                        options={projectOptions}
                                        value={
                                          project || // Use state value if available
                                          projectOptions?.find(
                                            (item) =>
                                              item.value === +question?.answer
                                          ) ||
                                          null // Fallback when data loads
                                        }
                                        menuPortalTarget={document.body}
                                        onChange={(e) => {
                                          setProject(e); // Update state with selected value
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors };
                                            delete newErrors[
                                              `${question.question_id}`
                                            ];
                                            return newErrors;
                                          });
                                          handleInputChange(
                                            e.value,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                        }}
                                        className={
                                          !projectOptions ? "form-disabled" : ""
                                        }
                                        name={`${question.question_id}`}
                                        id={question.question_id}
                                        styles={customStyles}
                                        placeholder="Select Project"
                                      />

                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {question.answer_type === "Users" && (
                                    <>
                                      <Select
                                        isMulti
                                        options={users}
                                        value={
                                          selectedUsers ||
                                          users?.filter((user) =>
                                            question?.users?.some(
                                              (item) => item === user.value
                                            )
                                          ) ||
                                          null // Fallback when data loads
                                        }
                                        menuPortalTarget={document.body}
                                        onChange={(e) => {
                                          setSelectedUsers(e); // Update state with selected value
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors };
                                            delete newErrors[
                                              `${question.question_id}`
                                            ];
                                            return newErrors;
                                          });
                                          handleUsersChange(
                                            e,
                                            question.question_id,
                                            sectionIndex,
                                            questionIndex
                                          );
                                        }}
                                        className={
                                          !users ? "form-disabled" : ""
                                        }
                                        name={`${question.question_id}`}
                                        id={question.question_id}
                                        styles={customStyles}
                                        placeholder="Select Users"
                                      />

                                      {errors[question.question_id] && (
                                        <div className="form-error-message">
                                          {errors[question.question_id]}
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {(question.answer_type === "Media" ||
                                    question.answer_type === "Video" ||
                                    question.answer_type === "Radio Buttons" ||
                                    question.answer_type === "CheckBox") && (
                                    <>
                                      {!(
                                        notes[question.question_id] ||
                                        notes[question.question_id] === ""
                                      ) && (
                                        <Button
                                          startIcon={<AddCircleOutline />}
                                          sx={{
                                            display: "flex",

                                            marginLeft: "auto",
                                          }}
                                          onClick={() => {
                                            setNotes((prevData) => {
                                              const newData = { ...prevData };

                                              // Use question.id as the key and set the value to the new value
                                              newData[question.question_id] =
                                                "";

                                              return newData;
                                            });
                                          }}
                                        >
                                          Add Note
                                        </Button>
                                      )}
                                    </>
                                  )}
                                  {(notes[question.question_id] ||
                                    notes[question.question_id] === "") && (
                                    <Box sx={{ mt: 2, position: "relative" }}>
                                      <TextField
                                        fullWidth
                                        label="Your Notes"
                                        multiline
                                        rows={3}
                                        variant="outlined"
                                        value={
                                          notes[question.question_id] || ""
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;

                                          // Update the notes in the state
                                          setNotes((prevData) => {
                                            const newData = { ...prevData };

                                            // Use question.id as the key and set the value to the new value
                                            newData[question.question_id] =
                                              value;

                                            return newData;
                                          });
                                        }}
                                        name="notes"
                                        placeholder="Add your notes here..."
                                      />

                                      <IconButton
                                        onClick={() => {
                                          setNotes((prevData) => {
                                            const newData = { ...prevData };

                                            delete newData[
                                              question.question_id
                                            ];

                                            return newData;
                                          });
                                        }}
                                        sx={{
                                          position: "absolute",
                                          top: "0px",
                                          right: "0px",
                                          fontSize: "1.1rem",
                                        }}
                                      >
                                        <CancelIcon
                                          sx={{ fontSize: "1.1rem" }}
                                        />
                                      </IconButton>
                                    </Box>
                                  )}
                                </Grid>
                              )
                            )}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                </form>
                {(formType === "inspection" || formType === "audit") && (
                  <Grid container spacing={2} sx={{ marginTop: "16px" }}>
                    {selectedUser && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1" component="label">
                          Auditor
                          {/* <span style={{ color: "red" }}> *</span> */}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ fontSize: "16px !important" }}
                        >
                          {selectedUser?.label}
                        </Typography>
                      </Grid>
                    )}

                    {signature && (
                      <Grid item xs={12}>
                        <Typography variant="body1" component="label">
                          Signature
                          {/* <span style={{ color: "red" }}> *</span> */}
                        </Typography>

                        <Box
                          style={{
                            border: "1px solid rgb(206, 212, 218)",

                            textAlign: "center",
                          }}
                          p={1}
                        >
                          <img
                            src={signature}
                            alt="signature"
                            width="auto"
                            height="200px"
                          />
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                )}
              </>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box className="footer">
        <Button className="secondary-footer-btn" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        {mode === "edit" && (
          <Button className="primary-footer-btn" onClick={handleSubmit}>
            Submit
          </Button>
        )}
      </Box>
    </>
  );
};

export default EditForm;
